import { render, staticRenderFns } from "./ProductSlider.vue?vue&type=template&id=7e99700f&scoped=true&"
import script from "./ProductSlider.vue?vue&type=script&lang=ts&"
export * from "./ProductSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSlider.vue?vue&type=style&index=0&id=7e99700f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e99700f",
  null
  
)

export default component.exports